module.exports = __webpack_public_path__ + "img/iron-vein.8aa75bd4.png";